export default __webpack_public_path__ + "media/zurb/img/about/culture/culture-img4-eca5a08ecdafe3ddc7e89f3442fae855.png";